var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { FontFamily } from '@atomic/obj.constants';
import { corPrimaria } from '../tema';
export var CircledLabelStyled = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  min-width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  border: ", " solid ", ";\n  font-family: ", ";\n  font-weight: bold;\n  font-size: ", ";\n  color: ", ";\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  min-width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  border: ", " solid ", ";\n  font-family: ", ";\n  font-weight: bold;\n  font-size: ", ";\n  color: ", ";\n"])), function (_a) {
    var size = _a.size;
    return (size === 'small' ? '38px' : '44px');
}, function (_a) {
    var size = _a.size;
    return (size === 'small' ? '38px' : '44px');
}, function (_a) {
    var size = _a.size;
    return (size === 'small' ? '0.25rem' : '0.3rem');
}, function (_a) {
    var theme = _a.theme;
    return corPrimaria(theme);
}, FontFamily.Secondary, function (_a) {
    var size = _a.size;
    return (size === 'small' ? '0.85rem' : '0.95rem');
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.itemColor;
});
var templateObject_1;
